import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, UserRound } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAccount } from "@/context/AccountContext";

const btn = "relative flex h-10 items-center gap-2 border border-line bg-ink-2 px-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors hover:border-acid";

export const AccountButton = () => {
  const { customer } = useAccount();
  return (
    <Link to={customer ? "/account" : "/account/accedi"} data-testid="navbar-account-button" aria-label={customer ? "Il mio account" : "Accedi"} className={`${btn} max-w-[180px]`}>
      <UserRound className={`h-4 w-4 shrink-0 ${customer ? "text-acid" : ""}`} />
      <span className="hidden truncate sm:inline">{customer ? customer.name.split(" ")[0] : "Accedi"}</span>
    </Link>
  );
};

export const CartButton = () => {
  const { count, setOpen } = useCart();
  return (
    <button data-testid="cart-toggle-button" onClick={() => setOpen(true)} aria-label="Apri carrello" className={btn}>
      <ShoppingBag className="h-4 w-4" />
      <span className="hidden sm:inline">Carrello</span>
      <motion.span key={count} initial={{ scale: 0.4 }} animate={{ scale: 1 }} data-testid="cart-count" className="flex h-5 min-w-5 items-center justify-center bg-acid px-1 text-[10px] font-medium text-ink">
        {count}
      </motion.span>
    </button>
  );
};
